import List from './List';

export default List;



// WEBPACK FOOTER //
// ./src/components/BlogsPage/components/List/index.js